import React from 'react';
import { getSimpleColorFromScore, useScreen } from '../../../styles';
import { get, set } from 'global/lib/lodash';
import clsx from 'clsx';
import { getColorFromScore } from '../../../styles';
import { ChartContainer, ChartRow, ChartWrap, Col, Container } from '../styles';
import { avgItems, sumCount } from '../utils';
import { cleanCopy } from '../../../utils';

export const HeatChart = (props) => {
  const { isMobile } = useScreen();
  const {
    chart,
    getDisplayVal,
    findHeaderRow,
    getHeaderTitle,
    headerAvgTitle,
    colKey,
    is2colcomp,
  } = props;

  const hasChartIndex = props.chartIndex !== undefined;
  const isSingleChart = !hasChartIndex;
  const useIndex = !props.chipFilters;

  const renderTable = (tab, i) => {
    if (hasChartIndex && props.chartIndex !== i && useIndex) { return null; }

    return (
      <Container
        key={i}
        isSingleChart={isSingleChart}
        isContainer
        isRemoveBox={hasChartIndex}
        is2colcomp={is2colcomp}
      >
        {!hasChartIndex && props.renderBar(tab, i)}
        <ChartContainer>
          <table>
            <thead className={'headercells'}>
              <ChartRow as="tr">
                <td></td>
                {chart.header.map((h, _i) => (
                  <HeaderCell key={_i} i={_i + 1} val={h} getHeaderTitle={getHeaderTitle} {...props} />
                ))}
              </ChartRow>
            </thead>
            <thead className="headerrow">
              <ChartRow as="tr" noTopBorder>
                <Col as="td">{headerAvgTitle(tab, props.showCounts)}</Col>
                {get(chart, `cols.${i}`, []).map((val, _i) => {
                  const ck = colKey(tab);
                  const __i = chart.is2colcomp && _i === 1 ? 0 : _i;
                  const foundHeaderRow = findHeaderRow(ck, val);
                  let cols = get(chart, `cols.${i}`);

                  if (chart.is2colcomp && _i === 1) {
                    cols = cleanCopy(get(chart, `cols.${i}`));
                    set(cols, '0.0.isComp', true);
                  }

                  const headerRowItems = __i === 0 ? findHeaderRow(ck, cols, true) || [] : [];

                  const value = ck
                    ? (__i === 0
                      ? (chart.isCompare && !chart.is2colcomp ? get(headerRowItems, '0.avgDiff', 0) : avgItems(headerRowItems.map((hr) => ({ value: parseFloat(get(hr, 'calculated_value', 0)) }))))
                      : parseFloat(get(foundHeaderRow, 'calculated_value')))
                    : avgItems(val);

                  const count = ck ? (__i === 0 ? headerRowItems.reduce((a, c) => a + get(c, 'count', 0), 0) : get(foundHeaderRow, 'count', 0)) : sumCount(val);

                  return (
                    <Cell
                      key={__i}
                      getDisplayVal={getDisplayVal}
                      i={_i + 1}
                      {...props}
                      val={{
                        config: get(
                          val.find((f) => f.config),
                          'config'
                        ),
                        value,
                        count,
                      }}
                    />
                  );
                })}
              </ChartRow>
            </thead>
            <tbody>
              {tab.rows.map((row, _i) => {
                return (
                  <ChartRow as="tr" key={_i}>
                    {row.map((r, __i) => (
                      <Cell key={__i} val={r} i={__i} {...props} getDisplayVal={getDisplayVal} />
                    ))}
                  </ChartRow>
                );
              })}
            </tbody>
          </table>
        </ChartContainer>
      </Container>
    )
  }

  return (
    hasChartIndex
      ? <div>{get(chart, 'tables', []).map(renderTable)}</div>
      : <ChartWrap>{get(chart, 'tables', []).map(renderTable)}</ChartWrap>
  )
};

const HeaderCell = (props) => {
  let { val, getHeaderTitle } = props;

  const hv = getHeaderTitle(props);
  val = hv.val;

  const display = get(val, 'value', get(val, 'name', typeof val === 'string' ? val : ''));
  const is2colcomp = get(props, 'chart.is2colcomp', false);
  const ind = (props.i % 2) === 0 ? '0' : '1';

  return (
    <Col as="td" className={clsx(is2colcomp && `isTwoCol_${ind}`)}>
      <div>
        <span>{display}</span>
        {is2colcomp && !!hv.header && ind === '0' && <span className='catHeader'>{hv.header}</span>}
      </div>
    </Col>
  );
};

export const Cell = (props) => {
  const { getDisplayVal, showCounts } = props;

  const { isLink, hasClick, scoreVal, display, slide } = getDisplayVal(props);

  const isSimpleScore = get(props, 'val.config.is_simple_score');

  const onClick = () => {
    if (isLink && hasClick) {
      hasClick();
    }
  };

  const hasCount = get(props, 'val.count');
  const tooltip = get(props, 'val.tooltip');
  const displayCounts = showCounts ? true : false;
  const isNaNo = ['N/A', 'N/O'].includes(display);
  const bg = slide && !displayCounts ? (isSimpleScore && !isNaNo ? getSimpleColorFromScore(scoreVal) : getColorFromScore(scoreVal, slide)) : '';
  const is2colcomp = get(props, 'chart.is2colcomp', false);

  return (
    <Col
      as="td"
      onClick={onClick}
      title={tooltip || (hasCount ? `${hasCount} values` : undefined)}
      style={{ backgroundColor: bg }}
      hasBg={!!bg}
      isLink={isLink}
      className={clsx(bg && 'cellBg', is2colcomp && `isTwoCol_${(props.i % 2) === 0 ? '0' : '1'}`)}
    >
      <span>{display}</span>
    </Col>
  );
};
